const atualizarFornecedores = (state, fornecedores) => {
    state.fornecedores = fornecedores;
    state.ultimaAtualizacaoListaFornecedor = new Date();
}

const atualizarFornecedor = (state, fornecedor) => {
    state.fornecedor = fornecedor;
}

const addFornecedor = (state, fornecedor) => {
    if (!fornecedor || fornecedor.id == null) return;

    const index = state.fornecedores.findIndex(item => item.id === fornecedor.id);
    if (index >= 0) {
        state.fornecedores.splice(index, 1, JSON.parse(JSON.stringify(fornecedor)));
    } else {
        state.fornecedores.push(JSON.parse(JSON.stringify(fornecedor)));
    }
    state.ultimaAtualizacaoListaFornecedor = new Date();
}

const updateFornecedor = (state, fornecedor) => {
    if (!fornecedor || fornecedor.id == null) return;

    const index = state.fornecedores.findIndex(item => item.id === fornecedor.id);
    if (index >= 0) {
        state.fornecedores.splice(index, 1, JSON.parse(JSON.stringify(fornecedor)));
    }
    state.ultimaAtualizacaoListaFornecedor = new Date();
}

export default {
    atualizarFornecedores,
    atualizarFornecedor,
    addFornecedor,
    updateFornecedor
}
